import React from 'react';
import { Link } from 'react-router-dom';
import Seo from '../components/Seo';
import PracticeHero from '../components/PracticeHero';
import PracticeMap from '../components/PracticeMap';
import PracticeBubbles from '../components/PracticeBubbles';
import PracticeDisciplines from '../components/PracticeDisciplines';
import PracticeRibbon from '../components/PracticeRibbon';
import PracticePrime from '../components/PracticePrime';
import PracticeSevenWays from '../components/PracticeSevenWays';
import PracticeValues from '../components/PracticeValues';

const Practice = () => {
  return (
    <div className="min-h-screen bg-white">
      <Seo
        title="practice — studio 2+2, Ahmedabad"
        description="studio 2+2 is a landscape architecture practice in Ahmedabad, India. 1000+ projects over nine years. taking care of your natural affairs."
      />
      <style>{`
        /* one text spine for every practice section (full-bleed elements opt out) */
        .pr-spine{ width:100%; max-width:1240px; margin:0 auto; padding:0 44px; }
        @media (max-width:760px){ .pr-spine{ padding:0 24px; } }
        /* oversized graphic numeral, right-aligned in a row's empty side */
        .pr-ghost{ position:absolute; right:0; bottom:0; font-family:Inter, sans-serif; font-weight:700;
          font-size:clamp(120px,16vw,230px); line-height:1; color:rgba(58,53,48,.06);
          pointer-events:none; user-select:none; letter-spacing:-.04em; }
        @media (max-width:880px){ .pr-ghost{ display:none; } }
        .pr-viewlink{ font-family:Inter, sans-serif; font-weight:600; font-size:14px; color:#002F6C; letter-spacing:0.02em; text-transform:lowercase; }
        .pr-viewlink:hover{ text-decoration:underline; }
        .pr-cta{ display:block; padding:80px 44px; text-align:center; background:#002F6C; color:#fff; text-decoration:none; transition:background .25s ease; }
        .pr-cta:hover{ background:#013a82; }
      `}</style>

      {/* Hero */}
      <PracticeHero />

      {/* Where We Work (map) */}
      <PracticeMap />

      {/* The Thousand — glass bubbles */}
      <PracticeBubbles />

      {/* Disciplines */}
      <PracticeDisciplines />

      {/* A few of the thousand — ribbon strip */}
      <PracticeRibbon />

      {/* PRIME — research */}
      <PracticePrime />

      {/* How we work — seven ways */}
      <PracticeSevenWays />

      {/* How we practice — four value slides */}
      <PracticeValues />

      {/* Closing — view projects link + talk-to-us CTA */}
      <div className="text-center" style={{ padding: '64px 24px 40px' }} data-testid="practice-viewprojects-wrap">
        <Link to="/work" className="pr-viewlink" data-testid="practice-viewprojects-link">
          view projects →
        </Link>
      </div>

      <Link to="/contact" className="pr-cta" data-cursor-invert data-testid="practice-cta-contact">
        <span style={{ fontFamily: 'Inter, sans-serif', fontWeight: 600, fontSize: 'clamp(24px,3.6vw,44px)', letterSpacing: '-0.02em', display: 'block' }}>
          talk to us about a project
        </span>
        <span style={{ display: 'block', fontFamily: 'Inter, sans-serif', fontWeight: 300, fontSize: '15px', letterSpacing: '0.2em', color: '#a9c3e4', marginTop: 14 }}>
          STUDIO 2+2 · AHMEDABAD, INDIA
        </span>
      </Link>
    </div>
  );
};

export default Practice;
